import React,{ useContext } from "react";
import { Link } from "gatsby-plugin-react-intl";
import HeaderBarContext from "../../context/HeaderBarContext";

type LinkProps = {
  to: string;
  children: React.ReactNode;
  className?: string;
};

function CustomLink({ to, children, className }: LinkProps) {
  const { setOpened } = useContext(HeaderBarContext);
  const handleClick = () => {
    setOpened(false);
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      className={className}
      style={{ textDecoration: "none" }}
    >
      {children}
    </Link>
  );
}

export default CustomLink;
